module.exports = __webpack_public_path__ + "static/assets/b18c55ff4aa5573ac9f5e7c12c1d12ab.svg";